import React, { useEffect, useState } from 'react'
import Layout from '../../../layouts/Layout'
import './draftcases.scss'
import Tabs from '../Tabs'
import Admin from 'api/Admin'

const thead = ['User', 'Purpose', "Despcription", 'Edit']

export default function DraftCases() {

  const [data, setData] = useState([])
  const [message, setMessage] = useState('')

  const getData = async () => {
    try {
      const res = await Admin.Case.getDraft()
      setData(res)
    } catch (error) {
      setMessage(error.message)
    }
  }

  
  useEffect(() => {
    getData()
  }, [])

  return (
    <Layout active={"AddCase"} title={"Draft Cases"}>
      <Tabs />
      {message}
      <div className='main-container'>
        <div className='draft-table-container'>
          <table>
            <thead>
              {thead.map(d => <td key={d} className='th'>{d}</td>)}
            </thead>
            <tbody></tbody>
          </table>
          <div className='no-data-found'>No Data Found</div>
        </div>
      </div>
    </Layout>
  )
}
